import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'censureEmailPipe'
})
export class CensureEmailPipe implements PipeTransform {
  transform(value: string): string | null | undefined {
    if (!value) { return value };
    const values: string[] = value.split("@")
    const numberFirstPart = 3

    if(values.length == 1) { return "******" };

    const letter1 = values[0].substring(0, numberFirstPart)
    const letter2 = values[1]

    return letter1 + "***@" + letter2
}

}
